module.exports = __webpack_public_path__ + "img/weight.b914a3bf.png";